import Vue from 'vue'
import API from './api'
import './http'
import { formatDate, handleValue } from './util'

Vue.prototype.$formatDate = formatDate
Vue.prototype.$handleValue = handleValue
Vue.prototype.API = API



// WEBPACK FOOTER //
// ./src/utils/index.js